<script lang="ts">
    import { onMount } from "svelte";
    import Employee from "../../Models/Employee";
    import Session from "../../Models/Session";
    import Logo from "../Logo/Logo.svelte";

    let phoneInput: HTMLInputElement;
    let phoneNumber: string = '';
    let PINInput: HTMLInputElement;
    let remindPINSMSCountdown: number = 0;

    function handleRemindPINCountdown() {
        remindPINSMSCountdown = 20;
        const counter = setInterval(() => {
            if (remindPINSMSCountdown == 0) clearInterval(counter);
            else remindPINSMSCountdown--;
        }, 1000);
    }

    async function handleLogin(e) {
        if (!e.key || e.key == 'Enter') {
            const phone = phoneInput.value;
            const PIN = PINInput.value;
            const auth = await Session.auth(phone, PIN);
            if (auth.token) {
                localStorage.setItem('fidrygalki_token', auth.token);
                window.location.replace('/#/dashboard');
            }
        }
    }

    async function remindPIN() {
        const res = await Employee.remindPIN(phoneNumber);
        if (res) handleRemindPINCountdown();
    }
</script>

<div on:keydown={handleLogin} class="form-structor">
    <div class="signup">
        <div class="logo">
            <Logo width="100" />
        </div>
        <div class="form-holder">
            <input bind:this={phoneInput} bind:value={phoneNumber} type="phone" class="input" placeholder="Numer telefonu" maxlength="9" />
            <input bind:this={PINInput} type="password" class="input" placeholder="PIN" maxlength="4" />
        </div>
        <button on:click={handleLogin} class="submit-btn">Zaloguj się</button>
        <small class="remindPIN">
            {#if !!remindPINSMSCountdown}
                <span>Wyślij ponownie za {remindPINSMSCountdown} sekund...</span>
            {:else}
                <span on:click={remindPIN}>{phoneNumber.length == 9 ? 'Nie pamiętasz numeru PIN?' : ''}</span>
            {/if}
        </small>
    </div>
</div>

<style type="text/scss">
    .form-structor {
        font-family: Arial;
        background-color: #222;
        border-radius: 15px;
        height: 550px;
        width: 350px;
        position: relative;
        overflow: hidden;

        &::after {
            content: "";
            opacity: 0.8;
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            background-repeat: no-repeat;
            background-position: left bottom;
            background-size: 500px;
            background-image: url("/assets/chair.jpg");
        }

        .signup {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 65%;
            z-index: 5;

            .logo {
                display: flex;
                justify-content: center;
            }

            .form-holder {
                border-radius: 15px;
                background-color: #fff;
                overflow: hidden;
                margin-top: 1.5rem;
                opacity: 1;
                visibility: visible;

                .input {
                    border: 0;
                    outline: none;
                    box-shadow: none;
                    display: block;
                    height: 30px;
                    line-height: 30px;
                    padding: 8px 15px;
                    border-bottom: 1px solid #eee;
                    width: 100%;
                    font-size: 12px;

                    &:first-of-type {
                        height: 45px;
                    }
                    &:last-child {
                        border-bottom: 0;
                    }
                    &::-webkit-input-placeholder {
                        color: rgba(0, 0, 0, 0.4);
                    }
                }
            }

            .submit-btn {
                background-color: rgba(0, 0, 0, 0.4);
                color: rgba(256, 256, 256, 0.7);
                border: 0;
                border-radius: 15px;
                display: block;
                margin: 1rem 0 .5rem 0;
                padding: 15px 45px;
                width: 100%;
                font-size: 13px;
                font-weight: bold;
                cursor: pointer;
                opacity: 1;
                visibility: visible;

                &:hover {
                    transition: all 0.3s ease;
                    background-color: rgba(0, 0, 0, 0.8);
                }
            }

            .remindPIN {
                display: block;
                height: 1rem;
                color: white;
                font-size: .6rem;
                cursor: pointer;
            }
        }
    }
</style>
